import React from "react";
import RouterDetail from "./routerDetail";


const RouterContent = ()=>{
    return(
        <RouterDetail/>
    )
}

export default RouterContent